<template>
  <div>
    <form id="delete" @submit.prevent="showModal = true">
        <input type="submit" class="submit" v-bind:value="$t('admin.adminGroupDelete.button.delete')">
    </form>
    <Modal class="alert" v-if="showModal" v-bind:modalTitle="$t('admin.adminGroupDelete.modal.header', {name: group.name})" @close="showModal = false">
      <p class="modal-text" v-html="$t('admin.adminGroupDelete.modal.text')"></p>
      <a v-on:click.prevent="deleteGroupProject" class="button" href="#">{{ $t("admin.adminGroupDelete.modal.button") }}</a>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue'

import { adminService } from '@/services/admin.service'

export default {
  props: ['group'],
  name: 'AdminGroupDelete',
  components: {
    Modal
  },
  data: function () {
    return {
      showModal: false
    }
  },
  methods: {
    deleteGroupProject: function () {
      adminService.projectList(this.group.id).then(async projects => {
        for(let project of projects){
          await this.deleteProject(project)
        }
        this.deleteGroup()
      }).catch((err) => {
        console.error('Something went wrong: ', err)
      })
    },
    deleteProject: function (project) {
      return new Promise(async (resolve) => {
        await adminService.projectDelete(project.id).then(() => {
          console.log('delete project: ' + project.name)
        }).catch((err) => {
          console.error('Unable to delete project: ', err)
        })
        resolve()
      })
    },
    deleteGroup: function () {
      adminService.groupDelete(this.group.id).then(() => {
        console.log('delete group: ' + this.group.name)
        this.showModal = false
        this.$router.push('/admin/planView/' + this.group.planId)
      }).catch((err) => {
        console.error('Unable to delete group: ', err)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.modal-text {
  font-weight: bold;
}
</style>
